<template>
  <section id="about" class="container about-us">
    <customeTitle
      :smallTitle="i18n('about.abt')"
      :title="i18n('about.title')"
      :description="i18n('about.note')"
    />

    <div class="content-container">
      <div v-for="n in 4" :key="n" data-aos="fade-up" :data-aos-delay="n * 200">
        <div class="c-card">
          <div class="icon-container" v-if="n == 1">
            <i class="fas fa-handshake"></i>
          </div>
          <div class="icon-container" v-if="n == 2">
            <i class="fas fa-globe"></i>
          </div>
          <div class="icon-container" v-if="n == 3">
            <i class="fas fa-trophy"></i>
          </div>
          <div class="icon-container" v-if="n == 4">
            <i class="fas fa-rocket"></i>
          </div>

          <h5 class="c-card-title">{{ i18n(`about.card${n}.title`) }}</h5>
          <p class="c-card-description">
            {{ i18n(`about.card${n}.description`) }}
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import customeTitle from "./customeTitle.vue";
export default {
  data() {
    return {
      bgImg: {
        backgroundImage: `url(${"https://firebasestorage.googleapis.com/v0/b/mining-israa-group.appspot.com/o/website%2Fhero%2Fabout.webp?alt=media&token=b146b050-78b8-45f6-a778-4f30f76f3910"})`,
      },
    };
  },
  methods: {
    //translation
    i18n(key, args) {
      return this.$t(key, args);
    },
  },
  components: {
    customeTitle,
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/variabls.scss";
@import "../assets/scss/elements/hero-branding.scss";
.gradient-overlay {
  background-image: linear-gradient(to bottom, white, #ffd89b, transparent);
}

// handle movement in rtl
.container-fluid {
  //    overflow: auto;
  background: white !important;
}
.hero-content {
  background-color: white;
  // overflow: auto;
}
h5 {
  font-size: 17px;
  margin-top: 25px;
  text-align: center;
}
.titlemove {
  text-align: center !important;
  @media only screen and (max-width: 425px) {
    font-size: 30px !important;
  }
}

.padding-0 {
  padding-left: 0 !important;
}
[dir="rtl"] .padding-0 {
  padding-right: 0 !important;
}
[dir="rtl"] .wordMove {
  text-align: right !important;
  margin-top: 10px;
}
.about-us {
  padding-top: 100px;
  padding-bottom: 100px;
}
.hero-content-item {
  @media only screen and (max-width: 320px) {
    font-size: 16px;
  }
  @media only screen and (max-width: 425px) {
    font-size: 12px;
  }
  @media only screen and (max-width: 160px) {
    font-size: 7px;
  }
  padding-right: 5px !important;
  padding-left: 5px !important;
}
.content-container {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 40px;
  justify-content: center;
}
.content-container .c-card {
  flex-grow: 1;
  width: 270px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  text-align: center;
  transition: all 0.25s ease-in-out;
}
.c-card:hover .icon-container {
  transform: scale(1.05);
  filter: drop-shadow(0px 0px 10px #121d74);
}

.c-card:hover {
  transform: scale(1.1);
}
.content-container .c-card .icon-container {
  padding: 20px;
  border: 1px solid #eee;
  width: fit-content;
  border-radius: 50%;
  width: 90px;
  height: 90px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
}
i {
  color: $main-color;
}
.content-container .c-card .c-card-title {
  font-size: 18px;
  font-weight: 600;
}

.content-container .c-card .c-card-description {
  font-size: 15px;
  color: #8492a6 !important;
}
</style>
